<template>
  <div class="tooltip-container text-center" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <div
      v-if="isHovered"
      class="tooltip-container__tooltip"
      :class="{
        'tooltip-container__tooltip-width-max-content': isWithMaxContent,
        'tooltip-container__tooltip-light': isLightMode,
        'tooltip-container__tooltip-right': isRightPosition,
        'tooltip-container__tooltip-left': isLeftPosition,
        'tooltip-container__tooltip-top': isTopPosition,
      }"
      :style="{ width: `${widthPX}px` }"
    >
      {{ text }}
      <slot name="customizeContent"></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'BaseTooltip',
    props: {
      text: {
        type: String,
        required: true,
      },
      isWithMaxContent: {
        type: Boolean,
        required: false,
      },
      isLightMode: {
        type: Boolean,
        required: false,
      },
      isRightPosition: {
        type: Boolean,
        required: false,
      },
      isLeftPosition: {
        type: Boolean,
        required: false,
      },
      isTopPosition: {
        type: Boolean,
        required: false,
      },
      widthPX: {
        type: Number,
        required: false,
      },
    },
    data() {
      return {
        isHovered: false,
      }
    },
    methods: {
      showTooltip() {
        this.isHovered = true
      },
      hideTooltip() {
        this.isHovered = false
      },
    },
  })
</script>

<style>
  .tooltip-container {
    position: relative;
    display: inline-block;
  }

  .tooltip-container__tooltip {
    width: 150px;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 5px;
    border-radius: 4px;
    font-size: 14px;
    z-index: 9999;
    top: 100%;
    left: 100%;
    transform: translateX(-50%);
    white-space: break-spaces;
  }

  .tooltip-container__tooltip-right {
    top: 2%;
    left: 200%;
  }

  .tooltip-container__tooltip-left {
    top: 100%;
    left: -200%;
  }

  .tooltip-container__tooltip-top {
    top: -100px;
  }

  .tooltip-container__tooltip-light {
    background-color: var(--color-background);
    color: var(--color-text-4);
    box-shadow: 0 2px 16px rgb(0 0 0 / 10%);
  }

  .tooltip-container__tooltip-width-max-content {
    width: max-content;
  }
</style>
